// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainMyAds {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 77px 16px 100px 16px;
}

.myAdsContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #FFF4D9;
    border-radius: 16px;
    padding: 25px 0;
    position: relative;
    min-height: calc(100vh - 170px);
}

.myAdsContentHeader {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px 24px 30px;
}

.myAdsContentHeaderTitle {
    font-family: Alegreya Sans;
    font-size: 32px;
    font-weight: 700;
    line-height: 25.6px;
    text-align: left;
    color: rgba(75, 45, 16, 1);
}

.myAdsContentHeaderButton {
    width: max-content;
    height: auto;
    padding: 8px 16px;
    border-radius: 16px;
    background: #FF6B00;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    font-family: Alegreya Sans;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
    text-align: left;
    color: #FFF4D9;
}

.myAdsEmptyImage {
    max-width: 600px;
    width: 60vw;
    height: auto;
    margin-top: 20px;
}

.myAdsEmptyColumn {
    display: flex;
    flex-direction: column;
    gap: 80px;
    width: 100%;
    height: calc(100vh - 240px);
    align-items: center;
    justify-content: flex-end;
}

.myAdsEmptyTextBlock {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 75px;
}

.myAdsEmptyText {
    color: #8E3B00;
    font-size: 19.27px;
    font-weight: 700;
    line-height: 23.12px;
    text-align: left;
    margin-top: -83px;
    -webkit-user-select: none;
            user-select: none;
    width: 52%;
}

.linkNoUnderlineCreate {
    text-decoration: none;
}

.adList {
    display: flex;
    position: relative;
    flex-direction: column;
    /* width: 100%; */
    gap: 32px;
    padding: 0 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/MyAds/MyAds.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,eAAe;AACnB","sourcesContent":[".mainMyAds {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    padding: 77px 16px 100px 16px;\n}\n\n.myAdsContent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    background: #FFF4D9;\n    border-radius: 16px;\n    padding: 25px 0;\n    position: relative;\n    min-height: calc(100vh - 170px);\n}\n\n.myAdsContentHeader {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 30px 24px 30px;\n}\n\n.myAdsContentHeaderTitle {\n    font-family: Alegreya Sans;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 25.6px;\n    text-align: left;\n    color: rgba(75, 45, 16, 1);\n}\n\n.myAdsContentHeaderButton {\n    width: max-content;\n    height: auto;\n    padding: 8px 16px;\n    border-radius: 16px;\n    background: #FF6B00;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    font-family: Alegreya Sans;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16.8px;\n    text-align: left;\n    color: #FFF4D9;\n}\n\n.myAdsEmptyImage {\n    max-width: 600px;\n    width: 60vw;\n    height: auto;\n    margin-top: 20px;\n}\n\n.myAdsEmptyColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 80px;\n    width: 100%;\n    height: calc(100vh - 240px);\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.myAdsEmptyTextBlock {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-left: 75px;\n}\n\n.myAdsEmptyText {\n    color: #8E3B00;\n    font-size: 19.27px;\n    font-weight: 700;\n    line-height: 23.12px;\n    text-align: left;\n    margin-top: -83px;\n    user-select: none;\n    width: 52%;\n}\n\n.linkNoUnderlineCreate {\n    text-decoration: none;\n}\n\n.adList {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    /* width: 100%; */\n    gap: 32px;\n    padding: 0 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
